import React from 'react';
import { SignedIn, SignedOut, SignInButton } from '@clerk/clerk-react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, Typography } from '@mui/material';
import { homeFeatures } from '../../data/features';

export interface PaywallModalProps {
  open: boolean;
  onClose: () => void;
  checkoutUrl: string | null;
  loading?: boolean;
  error?: string | null;
}

export const PaywallModal: React.FC<PaywallModalProps> = ({
  open,
  onClose,
  checkoutUrl,
  loading = false,
  error = null,
}) => {
  const helperText = error
    ? error
    : loading
      ? 'Preparing your checkout link…'
      : checkoutUrl
        ? 'You will be redirected to secure checkout.'
        : 'Generating your checkout link…';

  const handleCheckout = () => {
    if (checkoutUrl) {
      window.location.href = checkoutUrl;
    }
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>Upgrade to Premium</DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Unlock the full experience and organize YouTube the way you want.
        </Typography>

        <List sx={{ pl: 2, mb: 2 }}>
          {homeFeatures.map((feature, index) => (
            <ListItem key={index} sx={{ display: 'list-item', py: 0.5 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {feature.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {feature.description}
              </Typography>
            </ListItem>
          ))}
        </List>

        <Typography
          variant="caption"
          color={error ? 'error' : 'text.secondary'}
          sx={{ mt: 3, display: 'block' }}
        >
          {helperText}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 0, justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
        <Button onClick={onClose} disabled={loading}>
          Not now
        </Button>
        <SignedOut>
          <SignInButton mode="modal">
            <Button variant="contained" color="primary" disabled={loading}>
              Sign in to upgrade
            </Button>
          </SignInButton>
        </SignedOut>
        <SignedIn>
          <Button variant="contained" color="primary" onClick={handleCheckout} disabled={loading || !checkoutUrl}>
            Continue to checkout
          </Button>
        </SignedIn>
      </DialogActions>
    </Dialog>
  );
};

export default PaywallModal;
